export const arrayOverwriteSource = (destinationArray, sourceArray, options) => sourceArray
